import { useSocialPosts } from '../hooks/useSocialPosts';
import { PostCard } from '../components/PostCard';
import { Skeleton } from '@/components/ui/skeleton';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export function PublishedPage() {
  const navigate = useNavigate();
  const { posts, isLoading, error, loadMore, hasMore } = useSocialPosts('published');

  return (
    <div className="p-6 space-y-4">
      <h1 className="text-2xl font-bold">Published</h1>

      {error && <p className="text-sm text-destructive">{error}</p>}

      {isLoading ? (
        <div className="space-y-2">
          {[1, 2, 3].map((i) => (
            <Skeleton key={i} className="h-24 w-full" />
          ))}
        </div>
      ) : posts.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-muted-foreground mb-4">No published posts yet.</p>
          <Button onClick={() => navigate('/a/arche_social_media/compose')}>Create a post</Button>
        </div>
      ) : (
        <div className="space-y-2">
          {posts.map((post) => (
            <PostCard key={post.postId} post={post} />
          ))}
          {hasMore && (
            <Button variant="outline" className="w-full" onClick={loadMore}>
              Load more
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
